<div [ngClass]="extraModalClasses">
  <div class="modal-header">
    <button
      id="btnClose"
      type="button"
      class="btn-close close"
      aria-label="Close"
      (click)="onXClick()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    @if (titleText) {
      <h4 class="section-title modal-title float-start"
          [ngClass]="extraTitleClasses">
        {{ titleText }}
      </h4>
    }
  </div>
  <div
    class="modal-body"
    [ngClass]="extraTextClasses"
    [innerHTML]="messageText | safeHtml: SanitizerValueType.HTML"
  ></div>
  <div class="modal-footer justify-content-between">
    @if (declineBtnText) {
      <button class="btn btn-link btn-start"
              [ngClass]="extraDeclineBtnClasses"
              (click)="onDeclineClick()">
        {{ declineBtnText }}
      </button>
    }
    @if (confirmBtnText) {
      <button
        class="btn btn-primary"
        [ngClass]="extraConfirmBtnClasses"
        (click)="onConfirmClick()">
        {{ confirmBtnText }}
      </button>
    }
  </div>
</div>
